"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactDom = require("react-dom");
var _canUseDom = _interopRequireDefault(require("./../_utils/can-use-dom"));
var _usePortalContext2 = require("./use-portal-context");
// Shamelessly lifted from https://github.com/tajo/react-portal

var Portal = function Portal(props) {
  var _usePortalContext = (0, _usePortalContext2.usePortalContext)(),
    node = _usePortalContext.node;

  // If we can't use the DOM, don't even bother
  if (!_canUseDom["default"]) return null;

  // Where we're portalling to custom target node provided in the provider else defaulting to document.body
  var targetNode = node || document.body;
  // What's being rendered
  // TODO: In 8.x consider removing the parent <div>. This is here for
  // quasi-backwards compatibility where until 7.7.0 we were rendering
  // Portal's contents in a <div> added to the end of the document body.
  // Moving forward, it should be safe to render the children directly into
  // the portal:
  // ```
  // createPortal(props.children, targetNode)
  // ```
  var children = /*#__PURE__*/_react["default"].createElement("div", {
    ref: props.portalRef
  }, props.children);

  // If we're not tracking when user reaches the "end" of the Portal, create a
  // simple Portal with the passed in children targeting the passed in node
  // or the defaultNode
  if (!props.onReachEndOfPortal) {
    return /*#__PURE__*/(0, _reactDom.createPortal)(children, targetNode);
  }
  // Else, create both a portal for the children _and_ a div that, when focused,
  // calls Portal's `onReachEndOfPortal` method
  else {
    return [/*#__PURE__*/(0, _reactDom.createPortal)(children, targetNode), /*#__PURE__*/(0, _reactDom.createPortal)( /*#__PURE__*/_react["default"].createElement("div", {
      tabIndex: "0",
      onFocus: props.onReachEndOfPortal
    }), targetNode)];
  }
};
Portal.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node.isRequired,
  portalRef: _propTypes["default"].any,
  onReachEndOfPortal: _propTypes["default"].func
} : {};
var _default = Portal;
exports["default"] = _default;